var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
function IconVirtualTour(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 20 20" }, props),
        React.createElement("path", { fillRule: "evenodd", d: "M1.75 10c0-.985.727-2.034 2.25-2.88 1.498-.832 3.618-1.37 6-1.37s4.502.538 6 1.37c1.523.846 2.25 1.895 2.25 2.88 0 .685-.343 1.39-1.075 2.054-.734.665-1.818 1.245-3.162 1.642a.75.75 0 00.426 1.439c1.497-.443 2.8-1.115 3.743-1.97.945-.856 1.568-1.937 1.568-3.165 0-1.777-1.288-3.228-3.022-4.191C14.968 4.83 12.588 4.25 10 4.25s-4.968.581-6.728 1.559C1.537 6.772.25 8.223.25 10c0 1.777 1.287 3.228 3.022 4.191 1.535.853 3.543 1.404 5.75 1.531l-1.79 1.705a.75.75 0 001.035 1.086l3.158-3.01.57-.543-.57-.543-3.158-3.01a.75.75 0 00-1.034 1.086l1.812 1.728c-1.991-.123-3.75-.622-5.045-1.341-1.523-.846-2.25-1.895-2.25-2.88z", clipRule: "evenodd" })));
}
export default IconVirtualTour;
